import { NumberId } from 'src/app/shared/state/number-id.model';

export interface Project extends NumberId {
  name: string;
  description: string;
  owner: number;
  template: number;
  location: string;
  location_bounds: number[][];
  validated: boolean;
}

export function createProject(params: Partial<Project>) {
  return {
    ...params
  } as Project;
}

export enum ProjectUploadStatus {
  Waiting = 'Waiting',
  Processing = 'Processing',
  Processed = 'Processed',
  Error = 'Error',
}
